import {inject, injectable} from 'inversify';

import type {MetricApiModel} from '../../../../../../api/metrics/types';
import type {BNUserMetricsUpdateParams} from '../../../../../../api/types/bnrks/methods';
import type {CoreUserMetricsUpdateParams} from '../../../../../../api/types/core/methods';
import type {ApiReadResponse} from '../../../../../../api/types/types';

import {apiRequest} from '../../../../../../api/utils/apiRequest';
import {MetricMapperJrpc} from '../../../../../../core/domain/Metric/mappers/Metric.mapper.jrpc';
import {TrackWeightCmd} from '../TrackWeight.cmd';

@injectable()
export class TrackWeightCmdJrpc implements TrackWeightCmd {
  constructor(
    @inject(MetricMapperJrpc)
    private readonly mapper: MetricMapperJrpc,
  ) {}

  async exec({
    date,
    weightKg,
  }: TrackWeightCmd.Props): Promise<TrackWeightCmd.Response> {
    const {metrics}: ApiReadResponse<'metrics', MetricApiModel> =
      await apiRequest<BNUserMetricsUpdateParams | CoreUserMetricsUpdateParams>(
        {
          method: 'user.metrics.update',
          params: {
            date: date.toDateObj(),
            weight: weightKg,
          },
        },
      );

    return this.mapper.mapDataToModel(metrics);
  }
}
